export enum PopupTheme {
  Default,
  Carousel,
}
